module.exports = __webpack_public_path__ + "media/images/pages/i-belong/book_icon-ca32d00575bb41780376ce6fbdedf845.svg";